import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0211 = React.lazy(() => import('./symbols/0211_hand_touch_one_finger'));
const Symbol0212 = React.lazy(() => import('./symbols/0212_hand_touch_click_one_finger'));
const Symbol0213 = React.lazy(() => import('./symbols/0213_hand_touch_click_press_one_finger'));
const Symbol0214 = React.lazy(() => import('./symbols/0214_hand_touch_click_two_finger'));
const Symbol0215 = React.lazy(() => import('./symbols/0215_hand_two_finger_swipe_right'));
const Symbol0216 = React.lazy(() => import('./symbols/0216_hand_two_finger_swipe_left'));
const Symbol0217 = React.lazy(() => import('./symbols/0217_hand_two_finger_swipe_right'));
const Symbol0218 = React.lazy(() => import('./symbols/0218_hand_two_finger_swipe_left'));
const Symbol0219 = React.lazy(() => import('./symbols/0219_hand_one_finger_swipe_right'));
const Symbol0220 = React.lazy(() => import('./symbols/0220_hand_one_finger_swipe_left'));
const Symbol0221 = React.lazy(() => import('./symbols/0221_hand_one_finger_swipe_down_scroll'));
const Symbol0222 = React.lazy(() => import('./symbols/0222_hand_one_finger_swipe_up_scroll'));
const Symbol0223 = React.lazy(() => import('./symbols/0223_hand_two_finger_swipe_down'));
const Symbol0224 = React.lazy(() => import('./symbols/0224_hand_two_finger_swipe_up'));
const Symbol0225 = React.lazy(() => import('./symbols/0225_hand_two_finger_pinch_zoom'));
const Symbol0226 = React.lazy(() => import('./symbols/0226_hand_two_finger_pinch_zoom'));
const Symbol0227 = React.lazy(() => import('./symbols/0227_hand_three_finger_swipe_scroll_down'));
const Symbol0228 = React.lazy(() => import('./symbols/0228_hand_three_finger_swipe_scroll_up'));
const Symbol0229 = React.lazy(() => import('./symbols/0229_hand_three_finger_swipe_right'));
const Symbol0230 = React.lazy(() => import('./symbols/0230_hand_three_finger_swipe_left'));
const Symbol0231 = React.lazy(() => import('./symbols/0231_hand_finger_show_right'));
const Symbol0232 = React.lazy(() => import('./symbols/0232_hand_finger_show_left'));
const Symbol0233 = React.lazy(() => import('./symbols/0233_hand_fingers_grab_touch'));
const Symbol0233a = React.lazy(() => import('./symbols/0233a_hand_finger'));
const Symbol0233b = React.lazy(() => import('./symbols/0233b_hand_two_fingers'));

export interface IProps {}

const Gestures: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0211_hand_touch_one_finger" symbol={<Symbol0211 />} />
      <LazySymbol id="0212_hand_touch_click_one_finger" symbol={<Symbol0212 />} />
      <LazySymbol id="0213_hand_touch_click_press_one_finger" symbol={<Symbol0213 />} />
      <LazySymbol id="0214_hand_touch_click_two_finger" symbol={<Symbol0214 />} />
      <LazySymbol id="0215_hand_two_finger_swipe_right" symbol={<Symbol0215 />} />
      <LazySymbol id="0216_hand_two_finger_swipe_left" symbol={<Symbol0216 />} />
      <LazySymbol id="0217_hand_two_finger_swipe_right" symbol={<Symbol0217 />} />
      <LazySymbol id="0218_hand_two_finger_swipe_left" symbol={<Symbol0218 />} />
      <LazySymbol id="0219_hand_one_finger_swipe_right" symbol={<Symbol0219 />} />
      <LazySymbol id="0220_hand_one_finger_swipe_left" symbol={<Symbol0220 />} />
      <LazySymbol id="0221_hand_one_finger_swipe_down_scroll" symbol={<Symbol0221 />} />
      <LazySymbol id="0222_hand_one_finger_swipe_up_scroll" symbol={<Symbol0222 />} />
      <LazySymbol id="0223_hand_two_finger_swipe_down" symbol={<Symbol0223 />} />
      <LazySymbol id="0224_hand_two_finger_swipe_up" symbol={<Symbol0224 />} />
      <LazySymbol id="0225_hand_two_finger_pinch_zoom" symbol={<Symbol0225 />} />
      <LazySymbol id="0226_hand_two_finger_pinch_zoom" symbol={<Symbol0226 />} />
      <LazySymbol id="0227_hand_three_finger_swipe_scroll_down" symbol={<Symbol0227 />} />
      <LazySymbol id="0228_hand_three_finger_swipe_scroll_up" symbol={<Symbol0228 />} />
      <LazySymbol id="0229_hand_three_finger_swipe_right" symbol={<Symbol0229 />} />
      <LazySymbol id="0230_hand_three_finger_swipe_left" symbol={<Symbol0230 />} />
      <LazySymbol id="0231_hand_finger_show_right" symbol={<Symbol0231 />} />
      <LazySymbol id="0232_hand_finger_show_left" symbol={<Symbol0232 />} />
      <LazySymbol id="0233_hand_fingers_grab_touch" symbol={<Symbol0233a />} />
      <LazySymbol id="0233a_hand_finger" symbol={<Symbol0233b />} />
      <LazySymbol id="0233b_hand_two_fingers" symbol={<Symbol0233 />} />
    </>
  );
});

Gestures.displayName = 'Gestures';

export default Gestures;
